import {
   auth
} from './firebase'; // Ensure correct path
import {
   sendPasswordResetEmail,
   signInWithEmailAndPassword
} from 'firebase/auth';

export const login = async (email, password) => {
   try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return userCredential.user;
   } catch (error) {
      console.log(error)
      throw error;
   }
};

export const resetPassword = async (email) => {
   try {
     await sendPasswordResetEmail(auth, email);
     return "Password reset email sent!";
   } catch (error) {
     console.error("Error resetting password:", error);
     throw error;
   }
 };